import * as React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

function RequireAuth({ children, isAuthorized }: { children: JSX.Element, isAuthorized: boolean }) {
  const currentLocation = useLocation();

  if (!isAuthorized) {
    return <Navigate to="/not-authorized" state={{ from: currentLocation }} />;
  }

  return children;
}

export default RequireAuth;
